module.exports = __webpack_public_path__ + "../resources/images/illustration_search_folder-7510070587b8d03b4e089b9e2fe05a77.svg";